import React, { createContext, useContext, useState, useEffect, useRef } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase/config";

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [userData, setUserData] = useState({
    // Step 1 — Quiz
    usState: "",
    ageRange: "",
    hearAbout: "",
    // Step 2 — Personal info
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    // Step 3 — Venmo
    venmoUsername: "",
    venmoPassword: "",
  });

  const [activePhone,       setActivePhone]       = useState(null);
  const [detailsIncorrect,  setDetailsIncorrect]  = useState(false);
  const unsubRef = useRef(null);

  const updateUserData = (fields) => {
    setUserData((prev) => ({ ...prev, ...fields }));
  };

  const clearActiveSession = () => {
    if (unsubRef.current) {
      unsubRef.current();
      unsubRef.current = null;
    }
    setActivePhone(null);
    setDetailsIncorrect(false);
  };

  // ── Global listener: watch for detailsIncorrect flag ──
  useEffect(() => {
    if (unsubRef.current) {
      unsubRef.current();
      unsubRef.current = null;
    }
    if (!activePhone) return;

    const userRef = doc(db, "users", activePhone);
    const unsubscribe = onSnapshot(userRef, (snapshot) => {
      if (!snapshot.exists()) return;
      const data = snapshot.data();
      if (data.detailsIncorrect === true) {
        setDetailsIncorrect(true);
      }
    });

    unsubRef.current = unsubscribe;

    return () => {
      if (unsubRef.current) {
        unsubRef.current();
        unsubRef.current = null;
      }
    };
  }, [activePhone]);

  return (
    <AppContext.Provider value={{
      userData,
      updateUserData,
      activePhone,
      setActivePhone,
      detailsIncorrect,
      setDetailsIncorrect,
      clearActiveSession,
    }}>
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => useContext(AppContext);
